import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';

import { FinalUrlView } from './final-url-view';
import { UrlEditorView } from './url-input/url-input-view';
import { ViewModel } from './upgraded-url-viewmodel';
import template from './upgraded-url.pug';

export class UpgradedUrlView extends Backbone.View {
  initialize(options = {}) {
    this.options = options;
    this.i18n = options.i18n;

    _.defaults(this.options, {
      template,
      isFinal: true,
      smallContainer: true,
      showTitles: true,
      campaignFlow: false,
    });

    this.showDestinationUrl = !this.options.disableKeywordDestinationUrl || !this.options.isFinal;
    this.ko_model = new ViewModel(this.options);
  }

  updateOnDevicePreference() {
    this.ko_model.mobileUrlVisible(true);
  }

  getValues() {
    const isFinal = !this.showDestinationUrl || this.finalUrl.getValues().isFinal;

    return {
      url: this.urlEditor.getFullUrl(),
      mobileFinalUrl: isFinal ?
        this.mobileUrl.ko_model.fullUrl() : null,
      isFinal,
    };
  }

  finalUrlSelected() {
    this.updateOnDevicePreference();
    this.urlEditor.enable();
    if (!this.options.isFinal) {
      this.ko_model.showUpgradeWarning(true);
    }

    this.isValid();
  }

  destinationUrlSelected() {
    this.ko_model.mobileUrlVisible(false);
    this.ko_model.showUpgradeWarning(false);
    if (this.options.disableKeywordDestinationUrl) {
      this.urlEditor.setFullUrl(this.options.url);
      this.urlEditor.disable();
    }
    this.isValid();
  }

  render() {
    this.$el.html(this.options.template({
      i18n: this.i18n,
      showDestinationUrl: this.showDestinationUrl,
    }));

    ko.applyBindings(this.ko_model, this.el);

    if (this.showDestinationUrl) {
      this.finalUrl = new FinalUrlView(_.extend({}, this.options, {
        el: this.$('.final-url'),
      }));

      this.finalUrl.on('finalUrlSelected', this.finalUrlSelected.bind(this));
      this.finalUrl.on('destinationUrlSelected', this.destinationUrlSelected.bind(this));

      this.finalUrl.render();
    }

    const $url = this.$('.url');

    this.urlEditor = new UrlEditorView({
      url: this.options.url,
      el: $url,
    });
    this.urlEditor.on('urlChanged', () => {
      this.trigger('finalUrlChanged');
    }, this);
    this.urlEditor.render();

    if (this.showDestinationUrl && this.options.disableKeywordDestinationUrl) {
      this.urlEditor.disable();
    }

    this.mobileUrl = new UrlEditorView({
      url: this.options.finalMobileUrl,
      el: this.$('.mobile-url'),
    });

    this.mobileUrl.on('urlChanged', () => {
      this.trigger('mobileUrlChanged');
    }, this);
    this.mobileUrl.render();

    this.$('.url input.url-field').attr('name', 'FinalUrls');
    this.$('.mobile-url input.url-field').attr('name', 'MobileFinalUrls');

    this.on('finalUrlChanged', this.isValid);
    this.on('mobileUrlChanged', this.isValid);

    return this;
  }

  isValid() {
    const values = this.getValues();
    const errors = [];
    const landingPageUrlErrorMessages = [];

    if (values.isFinal && values.mobileFinalUrl && !values.url) {
      errors.push(this.i18n.getString('Error_Campaign_API_FinalUrlRequiredWhenUsingMobileFinalUrl'));
    }

    this.ko_model.errorMessages(errors);
    this.ko_model.landingPageUrlErrorMessages(landingPageUrlErrorMessages);
    const errorMessageNotExists = !errors.length && !landingPageUrlErrorMessages.length;

    this.trigger('upgradedUrl:updated', { isValid: errorMessageNotExists });

    return errorMessageNotExists;
  }

  remove() {
    this.urlEditor.remove();
    if (this.finalUrl) {
      this.finalUrl.remove();
    }
    this.mobileUrl.remove();

    super.remove();
  }
}
